<template>
  <v-container>
    <!-- Document Header -->
    <v-toolbar
      class="mb-4 elevation-1"
      flat
      style="background-color: #f8f9fa; border-bottom: 1px solid #e9ecef"
    >
      <div>
        <h1 class="text-h4 font-weight-medium mb-1" style="color: #495057">
          Comprobante de Egreso
        </h1>
        <div class="text-caption" style="color: #6c757d">
          Gestión de documentos de egreso • {{ formatDateHeader(new Date()) }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-chip
        color="#e9ecef"
        text-color="#495057"
        class="font-weight-medium"
        style="border: 1px solid #dee2e6"
      >
        <v-icon left small color="#6c757d">mdi-calendar</v-icon>
        {{ getCurrentDate() }}
      </v-chip>
    </v-toolbar>

    <!-- Main Document Card -->
    <v-card outlined elevation="2" class="mb-4">
      <!-- Header Section: Store (Left) - Client (Right) -->
      <v-container fluid class="pa-0">
        <v-row no-gutters>
          <!-- Store Information (Left) -->
          <v-col cols="12" md="6">
            <v-card
              flat
              tile
              class="pa-6"
              style="border-right: 1px solid #e9ecef; background-color: #ffffff"
            >
              <v-card-subtitle class="pa-0 mb-3 d-flex align-center">
                <v-icon color="#6c757d" size="20" class="mr-2">mdi-storefront</v-icon>
                <span
                  class="text-uppercase font-weight-medium text-body-1"
                  style="color: #495057"
                  >EMISOR</span
                >
              </v-card-subtitle>
              <v-card-text class="pa-0">
                <div class="text-h6 font-weight-medium mb-2" style="color: #212529">
                  {{ store.PartyName || store.store_name }}
                </div>
                <div class="text-body-1 mb-1" style="color: #495057">
                  NIT: {{ store.PartyIdentification || store.store_business_id }}
                </div>
                <div class="text-body-2 mb-1" style="color: #6c757d">
                  {{ store.AddressLine || store.store_address }}
                </div>
                <div class="text-body-2 mb-1" style="color: #6c757d">
                  {{ store.CityName || store.store_city }}
                </div>
                <div
                  v-if="store.store_phone"
                  class="text-body-2 mb-1"
                  style="color: #6c757d"
                >
                  <v-icon small class="mr-1" color="#6c757d">mdi-phone</v-icon>
                  Tel: {{ store.store_phone }}
                </div>
                <div v-if="store.store_email" class="text-body-2" style="color: #6c757d">
                  <v-icon small class="mr-1" color="#6c757d">mdi-email</v-icon>
                  Email: {{ store.store_email }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Client Information (Right) -->
          <v-col cols="12" md="6">
            <v-card flat tile class="pa-6" style="background-color: #ffffff">
              <v-card-subtitle
                class="pa-0 mb-3 d-flex justify-space-between align-center"
              >
                <div class="d-flex align-center">
                  <v-icon color="#6c757d" size="20" class="mr-2">mdi-account-cash</v-icon>
                  <span
                    class="text-uppercase font-weight-medium text-body-1"
                    style="color: #495057"
                    >PAGADO A</span
                  >
                </div>
                <v-btn
                  color="#6c757d"
                  text
                  small
                  @click="client_dialog = true"
                  class="font-weight-medium"
                  style="border: 1px solid #dee2e6; border-radius: 4px"
                >
                  <v-icon left small>mdi-pencil</v-icon>
                  {{ client.PartyName ? "Editar" : "Seleccionar" }}
                </v-btn>
              </v-card-subtitle>
              <v-card-text class="pa-0">
                <div v-if="client.PartyName">
                  <div class="text-h6 font-weight-medium mb-2" style="color: #212529">
                    {{ client.PartyName }}
                  </div>
                  <div class="text-body-1 mb-1" style="color: #495057">
                    {{ get_name_typeId(client.typeid) }}: {{ client.PartyIdentification }}
                  </div>
                  <div
                    v-if="client.AddressLine"
                    class="text-body-2 mb-1"
                    style="color: #6c757d"
                  >
                    <v-icon small class="mr-1" color="#6c757d">mdi-map-marker</v-icon>
                    {{ client.AddressLine }}
                  </div>
                  <div
                    v-if="client.CityName"
                    class="text-body-2 mb-1"
                    style="color: #6c757d"
                  >
                    <v-icon small class="mr-1" color="#6c757d">mdi-city</v-icon>
                    {{ getCityName(client.CityName) }}
                  </div>
                  <div
                    v-if="client.client_phone"
                    class="text-body-2 mb-1"
                    style="color: #6c757d"
                  >
                    <v-icon small class="mr-1" color="#6c757d">mdi-phone</v-icon>
                    Tel: {{ client.client_phone }}
                  </div>
                  <div
                    v-if="client.client_email"
                    class="text-body-2"
                    style="color: #6c757d"
                  >
                    <v-icon small class="mr-1" color="#6c757d">mdi-email</v-icon>
                    Email: {{ client.client_email }}
                  </div>
                </div>
                <v-alert
                  v-else
                  type="warning"
                  text
                  outlined
                  class="mt-3"
                  style="background-color: #fff3cd; border-color: #ffeaa7; color: #856404"
                >
                  <div class="text-center">
                    <v-icon size="32" class="mb-2" color="#856404"
                      >mdi-account-question</v-icon
                    >
                    <div class="text-body-1 mb-2" style="color: #856404">
                      Seleccionar beneficiario
                    </div>
                    <v-btn
                      color="#856404"
                      small
                      outlined
                      @click="client_dialog = true"
                      class="font-weight-medium"
                      style="border-color: #856404"
                    >
                      <v-icon left small>mdi-account-plus</v-icon>
                      Seleccionar
                    </v-btn>
                  </div>
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <!-- Items Section -->
      <v-container fluid class="pa-6">
        <v-row>
          <v-col cols="12">
            <v-card-subtitle class="pa-0 mb-4 d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <v-icon color="#6c757d" size="20" class="mr-2"
                  >mdi-text-box-multiple-outline</v-icon
                >
                <span
                  class="text-uppercase font-weight-medium text-body-1"
                  style="color: #495057"
                  >CONCEPTOS DEL COMPROBANTE</span
                >
              </div>
              <v-btn
                color="#6c757d"
                fab
                small
                elevation="1"
                @click="concepts_dialog = true"
                style="background-color: #6c757d; color: white"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-subtitle>

            <v-data-table
              :headers="headers"
              :items="concepts"
              :items-per-page="-1"
              hide-default-footer
              :loading="loading_status"
              loading-text="Cargando conceptos..."
              class="elevation-1"
              style="border: 1px solid #e9ecef; border-radius: 4px"
            >
              <template v-slot:[`item.item_concept`]="{ item }">
                <div class="d-flex align-center">
                  <v-icon small color="#6c757d" class="mr-2">mdi-tag-outline</v-icon>
                  <span class="font-weight-medium" style="color: #495057">{{
                    item.item_concept
                  }}</span>
                </div>
              </template>

              <template v-slot:[`item.item_note`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="text-truncate d-inline-block"
                      style="max-width: 300px; cursor: pointer; color: #6c757d"
                    >
                      {{ item.item_note }}
                    </span>
                  </template>
                  <span>{{ item.item_note }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.item_reference`]="{ item }">
                <v-chip
                  small
                  outlined
                  style="border-color: #dee2e6; color: #495057"
                  class="font-weight-medium"
                >
                  <v-icon left x-small color="#6c757d">mdi-file-document-outline</v-icon>
                  {{ item.item_reference }}
                </v-chip>
              </template>

              <template v-slot:[`item.item_value`]="{ item }">
                <span class="text-body-1 font-weight-medium" style="color: #495057">
                  {{ formatCurrency(item.item_value) }}
                </span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  icon
                  small
                  color="#dc3545"
                  @click="delete_concept(item)"
                  style="background-color: transparent"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </template>

              <template v-slot:body.append v-if="concepts.length > 0">
                <tr class="grey lighten-4 font-weight-bold">
                  <td colspan="3" class="text-right pr-4 py-3">
                    <span class="text-h6">Subtotal Conceptos</span>
                  </td>
                  <td class="text-right pr-4 py-3">
                    <span class="text-h5 font-weight-bold success--text">
                      {{ formatCurrency(sumField(concepts, "item_value")) }}
                    </span>
                  </td>
                  <td></td>
                </tr>
              </template>

              <template v-slot:no-data>
                <v-container class="text-center py-8">
                  <v-icon size="64" color="grey lighten-2">mdi-text-box-outline</v-icon>
                  <div class="text-h6 mt-4 grey--text">No hay conceptos agregados</div>
                  <div class="text-caption grey--text mt-2">
                    Haz clic en el botón + para incluir conceptos al comprobante
                  </div>
                  <v-btn
                    color="success"
                    outlined
                    class="mt-4"
                    @click="concepts_dialog = true"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Agregar Concepto
                  </v-btn>
                </v-container>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <!-- Bottom Section: Payments (Left) - Totals (Right) -->
      <v-container fluid class="pa-0">
        <v-row no-gutters style="min-height: 300px">
          <!-- Payment Methods (Left) -->
          <v-col
            cols="12"
            md="7"
            class="pa-6"
            style="border-right: 1px solid #e9ecef; background-color: #ffffff"
          >
            <div class="d-flex justify-space-between align-center mb-4">
              <div class="d-flex align-center">
                <v-icon color="#6c757d" size="20" class="mr-2">mdi-cash-multiple</v-icon>
                <span
                  class="text-uppercase font-weight-medium text-body-1"
                  style="color: #495057"
                  >FORMAS DE PAGO</span
                >
              </div>
              <v-btn
                color="#6c757d"
                text
                small
                @click="payment_dialogo = true"
                :disabled="concepts.length === 0"
                class="font-weight-medium"
                style="border: 1px solid #dee2e6; border-radius: 4px"
              >
                <v-icon left small>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </div>

            <div class="flex-grow-1">
              <v-simple-table v-if="payments.length > 0" class="transparent-table">
                <tbody>
                  <tr
                    v-for="(payment, index) in payments"
                    :key="index"
                    class="payment-row"
                  >
                    <td class="text-left py-3">
                      <div class="d-flex align-center">
                        <v-icon
                          small
                          class="mr-3"
                          :color="getPaymentColor(payment.payment_code)"
                          style="
                            background: rgba(255, 255, 255, 0.2);
                            border-radius: 50%;
                            padding: 8px;
                          "
                        >
                          {{ getPaymentIcon(payment.payment_code) }}
                        </v-icon>
                        <div>
                          <div class="font-weight-bold text-body-1">
                            {{ payment.payment_concept }}
                          </div>
                          <div class="text-caption opacity-8">
                            Ref: {{ payment.payment_reference }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-right py-3 font-weight-bold text-h6">
                      {{ formatCurrency(payment.payment_value) }}
                    </td>
                    <td class="text-right py-3" style="width: 50px">
                      <v-btn
                        icon
                        small
                        color="white"
                        @click="delete_payment(payment)"
                        style="background: rgba(255, 255, 255, 0.1)"
                      >
                        <v-icon small>mdi-delete-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-alert
                v-else
                type="info"
                text
                outlined
                class="mt-4"
                style="
                  background: rgba(255, 255, 255, 0.1);
                  border-color: rgba(255, 255, 255, 0.3);
                  color: white;
                "
              >
                <div class="text-center">
                  <v-icon class="mb-2">mdi-cash-remove</v-icon>
                  <div class="text-body-1 mb-2">
                    {{
                      concepts.length === 0
                        ? "Agregue conceptos primero"
                        : "No hay pagos registrados"
                    }}
                  </div>
                </div>
              </v-alert>
            </div>
          </v-col>

          <!-- Totals Summary (Right) -->
          <v-col
            cols="12"
            md="5"
            class="pa-6 d-flex flex-column"
            style="background-color: #ffffff"
          >
            <div class="mb-4">
              <v-icon color="#6c757d" size="20" class="mr-2">mdi-calculator</v-icon>
              <span
                class="text-uppercase font-weight-medium text-body-1"
                style="color: #495057"
                >RESUMEN DE TOTALES</span
              >
            </div>

            <div class="flex-grow-1 d-flex flex-column">
              <v-simple-table class="transparent-table">
                <tbody>
                  <tr>
                    <td class="text-left py-2">
                      <v-icon small class="mr-2" color="white">mdi-sigma</v-icon>
                      <strong class="text-body-1">Total Conceptos</strong>
                    </td>
                    <td class="text-right py-2 font-weight-bold text-h6">
                      {{ formatCurrency(sumField(concepts, "item_value")) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left py-2">
                      <v-icon small class="mr-2" color="white">mdi-cash-check</v-icon>
                      <strong class="text-body-1">Total Pagado</strong>
                    </td>
                    <td class="text-right py-2 font-weight-bold text-h6 warning--text">
                      {{ formatCurrency(sumField(payments, "payment_value")) }}
                    </td>
                  </tr>
                  <tr class="balance-row">
                    <td class="text-left py-3">
                      <v-icon small class="mr-2" :color="getBalanceColor()">
                        {{ getBalanceIcon() }}
                      </v-icon>
                      <strong class="text-h6">Saldo Pendiente</strong>
                    </td>
                    <td
                      class="text-right py-3 font-weight-bold text-h5"
                      :class="getBalanceClass()"
                    >
                      {{ formatCurrency(getBalance()) }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-alert
                :type="
                  getBalance() === 0 ? 'success' : getBalance() < 0 ? 'error' : 'warning'
                "
                text
                dense
                class="mt-4 mb-4"
                style="
                  background: rgba(255, 255, 255, 0.1);
                  border-color: rgba(255, 255, 255, 0.3);
                "
              >
                <div class="d-flex align-center">
                  <v-icon class="mr-2">{{ getBalanceIcon() }}</v-icon>
                  <span class="font-weight-bold">{{ getBalanceText() }}</span>
                </div>
              </v-alert>

              <v-spacer></v-spacer>

              <v-btn
                color="#495057"
                large
                block
                :disabled="!isReady()"
                :loading="loading_status"
                @click="save_receipt"
                class="mt-auto font-weight-medium"
                style="background-color: #495057; color: white; border-radius: 4px"
                elevation="1"
              >
                <v-icon left>mdi-printer</v-icon>
                Emitir Comprobante
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- Status Chip (Top Right) -->
    <v-chip
      v-if="isReady()"
      color="#28a745"
      class="status-chip elevation-1"
      style="background-color: #28a745; color: white; border: 1px solid #28a745"
    >
      <v-icon left small>mdi-check-circle</v-icon>
      <span class="font-weight-medium">Listo para emitir</span>
    </v-chip>
    <v-chip
      v-else-if="concepts.length > 0 || payments.length > 0"
      color="#ffc107"
      class="status-chip elevation-1"
      style="background-color: #ffc107; color: #212529; border: 1px solid #ffc107"
    >
      <v-icon left small>mdi-progress-clock</v-icon>
      <span class="font-weight-medium">En progreso</span>
    </v-chip>

    <!-- Client Dialog -->
    <v-dialog v-model="client_dialog" max-width="800px" persistent>
      <v-card elevation="10" style="border-radius: 16px; overflow: hidden">
        <v-toolbar
          class="error white--text"
          style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
        >
          <v-icon class="mr-3" size="28">mdi-account-cash</v-icon>
          <span class="text-h5 font-weight-bold">Información del Beneficiario</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="client_dialog = false" class="hover-scale">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="client.typeid"
                hide-details="auto"
                :items="setting['type_document_identifications']"
                item-value="id"
                item-text="name"
                label="Tipo de documento"
                outlined
                dense
                prepend-inner-icon="mdi-card-account-details"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="client.PartyIdentification"
                label="Número de documento"
                ref="idNumber"
                clearable
                hide-details="auto"
                outlined
                dense
                autofocus
                type="number"
                @keyup="validateID"
                @keypress="filter"
                @click:clear="clearClient"
                prepend-inner-icon="mdi-identifier"
                class="rounded-lg"
                style="border-radius: 8px"
              >
                <template v-slot:append-outer>
                  <v-btn
                    icon
                    color="primary"
                    elevation="2"
                    @click="get_rut"
                    :loading="loading_status"
                    class="rounded-circle"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="client.PartyName"
                label="Nombre Completo"
                hide-details="auto"
                outlined
                dense
                prepend-inner-icon="mdi-account"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.client_email"
                label="Correo Electrónico"
                hide-details="auto"
                outlined
                dense
                type="email"
                prepend-inner-icon="mdi-email"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.client_phone"
                label="Celular"
                hide-details="auto"
                outlined
                dense
                type="number"
                @keypress="filter"
                prepend-inner-icon="mdi-phone"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.AddressLine"
                label="Dirección"
                hide-details="auto"
                outlined
                dense
                prepend-inner-icon="mdi-map-marker"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="client.CityName"
                hide-details="auto"
                :items="setting['municipalities']"
                item-value="id"
                item-text="name"
                label="Ciudad"
                outlined
                dense
                prepend-inner-icon="mdi-city"
                class="rounded-lg"
                style="border-radius: 8px"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="client_dialog = false"
            class="text-capitalize font-weight-medium"
          >
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            elevation="3"
            @click="save_client"
            :loading="loading_status"
            class="text-capitalize font-weight-bold px-6"
            style="border-radius: 8px"
          >
            <v-icon left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Concepts Dialog -->
    <v-dialog v-model="concepts_dialog" max-width="700px" persistent>
      <v-form ref="conceptForm" v-model="validConcept" @submit="add2concepts">
        <v-card elevation="10" style="border-radius: 16px; overflow: hidden">
          <v-toolbar
            class="success white--text"
            style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
          >
            <v-icon class="mr-3" size="28">mdi-text-box-plus</v-icon>
            <span class="text-h5 font-weight-bold">Agregar Concepto</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              @click="concepts_dialog = !concepts_dialog"
              class="hover-scale"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-8">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="concept.item_code"
                  hide-details="auto"
                  :items="concept_lst"
                  item-value="codigo"
                  item-text="valor"
                  label="Concepto"
                  :rules="f_required"
                  outlined
                  dense
                  prepend-inner-icon="mdi-tag-text"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="concept.item_note"
                  label="Nota / Observación"
                  hide-details="auto"
                  :rules="f_required"
                  outlined
                  dense
                  rows="3"
                  autofocus
                  prepend-inner-icon="mdi-note-text"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="concept.item_reference"
                  label="Documento Referencia"
                  :rules="f_required"
                  hide-details="auto"
                  outlined
                  dense
                  prepend-inner-icon="mdi-file-document"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="concept.item_value"
                  label="Valor"
                  type="number"
                  clearable
                  :rules="f_required"
                  hide-details="auto"
                  outlined
                  dense
                  prepend-inner-icon="mdi-currency-usd"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-6">
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="concepts_dialog = false"
              class="text-capitalize font-weight-medium"
            >
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              elevation="3"
              type="submit"
              :disabled="!validConcept"
              class="text-capitalize font-weight-bold px-6"
              style="border-radius: 8px"
            >
              <v-icon left>mdi-plus</v-icon>
              Agregar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Payment Dialog -->
    <v-dialog v-model="payment_dialogo" max-width="700px" persistent>
      <v-form v-model="payvalid" ref="payform" @submit="addPayment">
        <v-card elevation="10" style="border-radius: 16px; overflow: hidden">
          <v-toolbar
            class="warning white--text"
            style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
          >
            <v-icon class="mr-3" size="28">mdi-cash-plus</v-icon>
            <span class="text-h5 font-weight-bold">Registrar Pagos</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              @click="payment_dialogo = !payment_dialogo"
              class="hover-scale"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-8">
            <v-alert
              v-if="totals.unpaid > 0"
              type="info"
              text
              dense
              class="mb-6 rounded-lg"
              style="border-radius: 8px"
            >
              <div class="d-flex align-center justify-space-between">
                <span class="font-weight-medium">Saldo pendiente por pagar:</span>
                <span class="font-weight-bold text-h6">{{
                  formatCurrency(totals.unpaid)
                }}</span>
              </div>
            </v-alert>

            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="pay_mode"
                  :items="FP"
                  return-object
                  item-value="codigo"
                  hide-details="auto"
                  item-text="valor"
                  label="Forma de pago"
                  outlined
                  dense
                  prepend-inner-icon="mdi-credit-card"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="payment.payment_reference"
                  label="Documento / Referencia"
                  :error="payRefe"
                  @keyup="updateRefe"
                  required
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-file-document"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="payment.payment_value"
                  label="Valor"
                  type="number"
                  :error="payValue"
                  clearable
                  :rules="payRule"
                  outlined
                  dense
                  required
                  hide-details="auto"
                  prepend-inner-icon="mdi-currency-usd"
                  class="rounded-lg"
                  style="border-radius: 8px"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-6">
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="payment_dialogo = false"
              class="text-capitalize font-weight-medium"
            >
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-btn
              color="warning"
              elevation="3"
              type="submit"
              :disabled="!payvalid"
              class="text-capitalize font-weight-bold px-6"
              style="border-radius: 8px"
            >
              <v-icon left>mdi-plus</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Print Navigation Drawer -->
    <v-navigation-drawer
      right
      class="navigation-drawer elevation-10"
      :value="showPrint"
      width="450px"
      app
      style="border-radius: 16px 0 0 16px"
    >
      <v-card height="100vh" style="border-radius: 16px 0 0 16px; overflow: hidden">
        <v-toolbar
          class="error white--text elevation-0"
          style="
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 16px 0 0 0;
          "
        >
          <v-toolbar-title class="text-h6 font-weight-bold"
            >Comprobante de Egreso</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            fab
            icon
            dark
            @click="showPrint = !showPrint"
            class="hover-scale"
            style="background: rgba(255, 255, 255, 0.1)"
          >
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0" style="height: calc(100vh - 112px); overflow: hidden">
          <v-img
            height="100%"
            width="100%"
            class="white"
            :src="invoiceImg"
            style="object-fit: contain"
          ></v-img>
        </v-card-text>
        <v-toolbar
          class="fixed-footer elevation-5"
          style="
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            border-radius: 0 0 16px 0;
          "
        >
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            elevation="3"
            @click="printReceipt"
            class="font-weight-bold px-6"
            style="border-radius: 8px"
          >
            <v-icon left>mdi-printer</v-icon>
            Imprimir
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-navigation-drawer>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver, fe_ws } from "@/services/webserver.js";
import createClient from "@/utils/createClient.js";
import createPayment from "@/utils/createPayment.js";
import create_item from "@/utils/create_item.js";
import settings from "@/utils/settings.js";

export default {
  components: {},
  data() {
    return {
      // Settings
      setting: settings(),

      // UI State
      client_dialog: false,
      payment_dialogo: false,
      concepts_dialog: false,
      loading_status: false,
      validConcept: false,
      payvalid: false,
      showPrint: false,

      // Snackbar
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },

      // Data
      invoiceImg: null,
      signature: null,
      payment: createPayment(),
      totals: { qty: 0, total: 0, tax: 0, paid: 0, unpaid: 0 },

      // Lists
      id_lst: [
        { code: "13", name: "Cédula de ciudadanía" },
        { code: "31", name: "NIT" },
        { code: "11", name: "Registro civil" },
        { code: "12", name: "Tarjeta de identidad" },
        { code: "21", name: "Tarjeta de extranjería" },
        { code: "22", name: "Cédula de extranjería" },
        { code: "41", name: "Pasaporte" },
        { code: "42", name: "Documento de identificación extranjero" },
        { code: "50", name: "NIT de otro país" },
      ],

      // Headers
      headers: [
        {
          text: "Concepto",
          align: "start",
          sortable: false,
          value: "item_concept",
        },
        {
          text: "Nota / Observación",
          align: "start",
          sortable: false,
          value: "item_note",
        },
        {
          text: "Referencia",
          align: "center",
          sortable: false,
          value: "item_reference",
        },
        {
          text: "Valor",
          align: "end",
          sortable: false,
          value: "item_value",
        },
        { text: "", value: "actions", align: "center", sortable: false },
      ],

      headers_payments: [
        {
          text: "Concepto",
          align: "start",
          value: "payment_concept",
        },
        {
          text: "Valor",
          align: "end",
          sortable: false,
          value: "payment_value",
        },
        { text: "", value: "actions", align: "center", sortable: false },
      ],

      // Models
      store: createClient(),
      concept: create_item(),
      concepts: [],
      concept_lst: [],
      payments: [],
      payRefe: false,
      payValue: false,
      pay_mode: {
        codigo: "01",
        valor: "EFECTIVO",
      },
      FP: null,
      client: createClient(),
      signatureStock: null,

      // Validation
      f_required: [(v) => !!v || "Campo requerido"],
      payRule: [
        (v) => !!v || "Forma de pago requerida",
        (v) =>
          (v && v <= this.totals.unpaid) ||
          "Valor max " + this.totals.unpaid.toLocaleString(2),
      ],
    };
  },

  mounted() {
    this.store = window.store;
    this.concept_lst = window.settings["GASTOS"];
    this.FP = window.settings.FP;
  },

  methods: {
    // Date formatting
    formatDateHeader(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    getCurrentDate() {
      return new Date().toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    // Format currency
    formatCurrency(value) {
      if (!value && value !== 0) return "$0";
      return (
        "$" +
        parseFloat(value).toLocaleString("es", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      );
    },

    // Utilities for new design
    getCityName(cityId) {
      if (!cityId) return "No especificada";
      const city = this.setting["municipalities"].find((m) => m.id === cityId);
      return city ? city.name : cityId;
    },

    getPaymentIcon(code) {
      const icons = {
        "01": "mdi-cash",
        "02": "mdi-credit-card",
        "03": "mdi-bank-transfer",
        "04": "mdi-checkbook",
      };
      return icons[code] || "mdi-cash-multiple";
    },

    getPaymentColor(code) {
      const colors = {
        "01": "success",
        "02": "primary",
        "03": "info",
        "04": "warning",
      };
      return colors[code] || "grey";
    },

    // Balance calculations
    getBalance() {
      const total = this.sumField(this.concepts, "item_value");
      const paid = this.sumField(this.payments, "payment_value");
      return total - paid;
    },

    getBalanceClass() {
      const balance = this.getBalance();
      if (balance === 0) return "success--text";
      if (balance < 0) return "error--text";
      return "warning--text";
    },

    getBalanceColor() {
      const balance = this.getBalance();
      if (balance === 0) return "success";
      if (balance < 0) return "error";
      return "warning";
    },

    getBalanceIcon() {
      const balance = this.getBalance();
      if (balance === 0) return "mdi-check-circle";
      if (balance < 0) return "mdi-alert-circle";
      return "mdi-clock-alert";
    },

    getBalanceText() {
      const balance = this.getBalance();
      if (balance === 0) return "Balanceado";
      if (balance < 0) return "Sobrepago";
      return "Pendiente";
    },

    isReady() {
      return (
        this.concepts.length > 0 &&
        this.client.PartyIdentification &&
        this.getBalance() === 0
      );
    },

    // Show message
    showMessage(text, color = "info", timeout = 3000) {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout,
      };
    },

    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    onBegin() {
      console.log("=== Begin ===");
    },

    onEnd() {
      console.log("=== End ===");
    },

    sumField(fld, key) {
      var dta = fld;
      return dta.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },

    get_name_typeId(e) {
      var index = this.id_lst.findIndex((itm) => itm.code === e);
      if (index >= 0) {
        return this.id_lst[index].name;
      }
    },

    get_concept_text(e) {
      var index = this.concept_lst.findIndex((itm) => itm.codigo === e);
      if (index >= 0) {
        return this.concept_lst[index].valor;
      }
    },

    validateID(e) {
      if (e.keyCode === 13) {
        this.get_rut();
      }
    },

    clearClient() {
      this.client = createClient();
      this.client.CityName = window.seller.city_code;
    },

    get_rut() {
      this.loading_status = true;
      var qry = {
        id_company: window.seller.PartyIdentification,
        method: "POST",
        nit: this.client.PartyIdentification,
        data: [],
      };

      fe_ws("get_rut", qry, (data) => {
        this.loading_status = false;
        var rut = JSON.parse(data);

        if (rut.business_name) {
          this.client.PartyName = rut.business_name;
          this.client.typeid = "6";
          this.get_fe_email();
        } else {
          if (rut.first_name) {
            this.client.PartyName =
              rut.first_name + " " + rut.surname + " " + rut.second_surname;
            this.client.typeid = "3";
            this.get_fe_email();
          } else {
            this.client = createClient();
            this.client.CityName = this.company.city_code;
            this.showMessage("Cliente no encontrado", "warning");
          }
        }
      });
    },

    get_fe_email() {
      this.loading_status = true;
      var qry = {
        id_company: window.seller.PartyIdentification,
        method: "POST",
        nit: this.client.PartyIdentification,
        data: [],
      };

      fe_ws("get_rut_email", qry, (data) => {
        this.loading_status = false;
        var rut_email = JSON.parse(data);
        if (rut_email.email) {
          this.client.client_email = rut_email.email;
          this.get_client(this.client.PartyIdentification, false);
        } else {
          this.get_client(this.client.PartyIdentification, true);
        }
      });
    },

    get_client(e, mail) {
      var qry = {
        store: window.store.store_id,
        PartyIdentification: this.client.PartyIdentification,
      };

      webserver("get_client_info", qry, (data) => {
        if (mail && data.client_email && data.client_email !== "") {
          this.client.client_email = data.client_email;
        } else {
          if (mail) this.client.client_email = "";
        }
        if (data.AddressLine && data.AddressLine !== "") {
          this.client.AddressLine = data.AddressLine;
        } else {
          this.client.AddressLine = "";
        }
        if (data.client_phone && data.client_phone !== "") {
          this.client.client_phone = data.client_phone;
        } else {
          this.client.client_phone = "";
        }
        if (
          data.CityName &&
          data.CityName !== "" &&
          this.containsOnlyNumbers(data.CityName)
        ) {
          this.client.CityName = data.CityName;
        } else {
          this.client.CityName = this.company.city_code;
        }
      });
    },

    save_client() {
      var qry = {
        store: window.store.store_id,
        party: this.client,
      };

      webserver("put_client_info", qry, () => {
        this.client_dialog = false;
        this.showMessage("Cliente guardado exitosamente", "success");
      });
    },

    add2concepts(e) {
      e.preventDefault();
      this.$refs.conceptForm.validate();

      if (this.validConcept) {
        const newItem = { ...this.concept };
        newItem.item_value = parseFloat(newItem.item_value);
        newItem.price = parseFloat(newItem.item_value);
        newItem.item_concept = this.get_concept_text(newItem.item_code);
        newItem.quantity = 1;

        this.concepts.push(newItem);
        this.updateTotal();
        this.concept = create_item();
        this.concepts_dialog = false;

        this.showMessage("Concepto agregado", "success");
      }
    },

    updateTotal() {
      this.totals.qty = 0;
      this.totals.total = 0;
      this.totals.tax = 0;
      this.totals.paid = 0;
      this.totals.unpaid = 0;

      this.concepts.forEach((itm) => {
        this.totals.qty += parseFloat(itm.quantity);
        this.totals.total += parseFloat(itm.quantity) * parseFloat(itm.price);
      });

      this.payments.forEach((itm) => {
        this.totals.paid += parseFloat(itm.payment_value);
      });

      this.totals.unpaid = this.totals.total - this.totals.paid;
      this.payment.payment_value = this.totals.unpaid;

      if (
        this.totals.unpaid === 0 &&
        this.concepts.length > 0 &&
        this.payments.length > 0
      ) {
        this.payment_dialogo = false;
        this.topay = true;
      } else {
        this.topay = false;
      }
    },

    addPayment(e) {
      e.preventDefault();

      if (this.pay_mode) {
        if (this.pay_mode.codigo === "01") {
          this.payment.payment_concept = this.pay_mode.valor;
          this.payment.payment_code = this.pay_mode.codigo;
          this.payments.push({ ...this.payment });
          this.updateTotal();

          if (this.totals.unpaid < 0) {
            var cambio = {
              payment_concept: "CAMBIO",
              payment_code: "01",
              payment_value: this.totals.unpaid,
            };
            this.payments.push({ ...cambio });
            this.updateTotal();
          }

          this.pay_mode = {
            codigo: "01",
            valor: "EFECTIVO",
          };
          this.payment_dialogo = false;
          this.showMessage("Pago agregado", "success");
        } else {
          if (this.payment.payment_value <= this.totals.unpaid) {
            this.payment.payment_concept = this.pay_mode.valor;
            this.payment.payment_code = this.pay_mode.codigo;
            this.payments.push({ ...this.payment });
            this.updateTotal();
            this.pay_mode = {
              codigo: "01",
              valor: "EFECTIVO",
            };
            this.payment_dialogo = false;
            this.showMessage("Pago agregado", "success");
          } else {
            this.payValue = true;
            this.payment.payment_value = 0;
            this.showMessage("El valor excede el monto pendiente", "error");
          }
        }
      }
    },

    updateRefe() {
      if (this.payment.payment_reference.length > 0) {
        this.payRefe = false;
      }
    },

    save_receipt() {
      if (this.concepts.length === 0) {
        this.showMessage("Debe agregar al menos un concepto", "warning");
        return;
      }

      if (this.payments.length === 0) {
        this.showMessage("Debe agregar al menos una forma de pago", "warning");
        return;
      }

      if (this.totals.unpaid !== 0) {
        this.showMessage("El pago no está completo", "warning");
        return;
      }

      this.loading_status = true;

      var qry = {
        doc: {
          doc_type: "CS-OUT",
          doc_value: this.totals.paid,
          store: window.store.store_id,
          userId: window.profile.user_email,
        },
        items: this.concepts,
        payments: this.payments,
        paidTo: this.client,
        seller: window.seller,
        store: window.store.store_id,
      };

      webserver(
        "receipt_save",
        qry,
        (data) => {
          this.loading_status = false;
          this.showMessage("Comprobante guardado exitosamente", "success");
          this.print_doc(data);
          this.resetDoc();
        },
        () => {
          this.loading_status = false;
          this.showMessage("Error al guardar el comprobante", "error");
        }
      );
    },

    resetDoc() {
      this.payments = [];
      this.concepts = [];
      this.client = createClient();
      this.updateTotal();
    },

    delete_payment(e) {
      var index = this.payments.indexOf(e);
      if (index !== -1) {
        this.payments.splice(index, 1);
        this.updateTotal();
        this.showMessage("Pago eliminado", "info");
      }
    },

    delete_concept(e) {
      var index = this.concepts.indexOf(e);
      if (index !== -1) {
        this.concepts.splice(index, 1);
        this.updateTotal();
        this.showMessage("Concepto eliminado", "info");
      }
    },

    printReceipt() {
      if (this.invoiceImg) {
        var a = window.open("", "", "height=600, width=400");
        a.document.write('<img src="' + this.invoiceImg + '" width="100%">');
        a.print();
        a.document.close();
        setTimeout(() => {
          a.close();
        }, 500);
      }
    },

    print_doc(data) {
      var LS = 50;
      var itemsQty = data.items.length * LS * 3;
      const elem = document.createElement("canvas");
      elem.width = 945;
      elem.height = 1800 + itemsQty;
      var total = 0;
      var center = elem.width / 2;
      var left = 10;
      var line = 150;
      var right = elem.width - left;
      const ctx = elem.getContext("2d");

      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";

      ctx.font = "bold 60px Arial";
      ctx.fillText(window.seller.PartyIdentification_Id, center, line);
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.fillText(window.seller.PartyName, center, line);
      line += LS;
      ctx.fillText("Nit : " + window.seller.PartyIdentification, center, line);

      line += LS;
      ctx.fillText(
        window.seller.AddressLine + ", " + window.seller.CityName,
        center,
        line
      );
      line += LS;
      ctx.font = "bold 35px Arial";
      ctx.fillText("COMPROBANTE DE EGRESO", center, line);
      ctx.font = "bold 40px Arial";
      line += LS;
      ctx.fillText("No. " + data.document.doc_number, center, line);
      line += LS;
      ctx.fillText(data.document.issueDate, center, line);
      line += LS;
      ctx.textAlign = "start";
      ctx.fillText("C.C./Nit : " + data.buyer.PartyIdentification, left, line);
      line += LS;
      ctx.fillText("Nombre    : " + data.buyer.PartyName, left, line);
      line += LS;
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";
      ctx.fillText("Concepto", center, line);
      line += LS;
      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;
      var tdiscount = 0;

      data.items.forEach((row) => {
        var price = row.price * row.quantity;
        var discount = row.discount * row.quantity;
        ctx.textAlign = "start";
        ctx.fillText(row.item_concept, left, line);
        line += LS;
        ctx.textAlign = "start";
        ctx.fillText(row.item_note, left, line);
        ctx.textAlign = "end";
        ctx.fillText(price.toLocaleString(), right, line);
        line += LS;
        ctx.textAlign = "start";
        ctx.fillText(row.item_reference, left, line);

        line += LS;
        total = total + price;
        tdiscount = tdiscount + discount;
      });
      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;

      line += LS;

      ctx.textAlign = "center";
      ctx.fillText("Formas de pago", center, line);
      line += LS;

      data.payment.forEach((item) => {
        item.valor = parseInt(item.valor);
      });

      data.payment.forEach((row) => {
        ctx.textAlign = "start";
        ctx.fillText(row.payment_concept + " - " + row.payment_reference, left, line);
        ctx.textAlign = "end";
        ctx.fillText(row.payment_value.toLocaleString(), right, line);
        line += LS;
      });
      line += LS;

      line += LS;
      line += LS;

      this.dataURL = elem.toDataURL();
      this.invoiceImg = this.dataURL;
      this.showPrint = true;
    },

    // Helper methods for consistency with the new design
    containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },
  },
};
</script>

<style scoped>
.status-chip {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 5;
  border-radius: 4px;
  font-size: 14px;
}

.fixed-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e9ecef;
}

.transparent-table {
  background: transparent;
}

.transparent-table tbody tr {
  background: transparent !important;
}

.payment-row {
  transition: all 0.2s ease;
}

.payment-row:hover {
  background: rgba(108, 117, 125, 0.1) !important;
}

.balance-row {
  background: #f8f9fa !important;
  border-radius: 4px;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* Enhanced form fields */
.v-text-field--outlined fieldset {
  border-width: 1px;
  border-radius: 4px;
  border-color: #dee2e6;
}

.v-text-field--outlined:hover fieldset {
  border-color: #adb5bd !important;
}

/* Data table enhancements */
.v-data-table {
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.v-data-table thead th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #dee2e6;
}

.v-data-table tbody tr:nth-child(even) {
  background: #f8f9fa;
}

.v-data-table tbody tr:hover {
  background: #e9ecef !important;
  transition: background-color 0.2s ease;
}

/* Button styles */
.v-btn {
  border-radius: 4px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
}

/* Dialog animations */
.v-dialog__content .v-card {
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style>
